import R from 'ramda'

/**
 * Mark a folder in myFolders as published
 * @param {Object} config
 * @param {number} config.folderId - the ID of the folder to be updated
 * @param {string} config.eslPublishedAt - the datestring from the folder's eslPublishedAt field
 * @param {Object[]} config.myFolders - the current myFolders array from the application state
 */
export function withFolderPublished({ folderId, eslPublishedAt, myFolders }) {
  const index = R.findIndex(R.propEq('id', folderId), myFolders)

  if (index < 0)
    throw new Error(
      `withPublishedFolder: Folder with id ${folderId} not found in myFolders`
    )

  return R.adjust(index, R.mergeLeft({ eslPublishedAt }), myFolders)
}

/**
 * Mark a folder in myFolders as not published
 * @param {Object} config
 * @param {number} config.folderId - the ID of the folder to be updated
 * @param {Object[]} config.myFolders - the current myFolders array from the application state
 */
export function withFolderUnpublished({ folderId, myFolders }) {
  const index = R.findIndex(R.propEq('id', folderId), myFolders)

  if (index < 0)
    throw new Error(
      `withPublishedFolder: Folder with id ${folderId} not found in myFolders`
    )

  return R.adjust(index, R.mergeLeft({ eslPublishedAt: null }), myFolders)
}

/**
 * Add a folder to the publishedFolders array
 * @param {Object} config
 * @param {Object} config.folder - the folder to add
 * @param {Object[]} config.publishedFolders - the current publishedFolders array from the application state
 */
export function addPublishedFolder({ folder, publishedFolders }) {
  return R.append(folder, publishedFolders)
}

/**
 * Remove a folder from the publishedFolders array
 * @param {Object} config
 * @param {number} config.folderId - the ID of the folder to be removed
 * @param {Object[]} config.publishedFolders - the current publishedFolders array from the application state
 */
export function removePublishedFolder({ folderId, publishedFolders }) {
  const folder = R.find(R.propEq('id', folderId), publishedFolders)

  if (!folder)
    throw new Error(
      `removePublishedFolder: Folder with id ${folderId} not found in publishedFolders`
    )

  return R.without([folder], publishedFolders)
}
